import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Directive, ElementRef, Inject, OnDestroy, Renderer2 } from '@angular/core';
import { App } from '@df/core/app';
import { injectTimeoutService } from '@df/ng/timeout.service';

@Directive({
    selector: 'input[scrollIntoView], textarea[scrollIntoView]',
    standalone: true
})
export class ScrollIntoViewDirective implements AfterViewInit, OnDestroy {
    protected focusListen: (() => void) | null = null;
    protected timeoutService = injectTimeoutService();

    constructor(
        protected elementRef: ElementRef,
        protected renderer: Renderer2,
        protected app: App,
        @Inject(DOCUMENT) protected documentRef: Document
    ) {}

    ngAfterViewInit() {
        if (this.app.isPlatformBrowser) {
            this.focusListen = this.renderer.listen(this.elementRef.nativeElement, 'focus', () => this.scroll());
        }
    }

    ngOnDestroy(): void {
        if (this.focusListen) {
            this.focusListen();
        }
    }

    protected scroll(): void {
        this.timeoutService.setTimeout(() => {
            this.elementRef.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
        }, 10);
    }
}
